import Svg, { Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const Share = ({ width = 16, height = 16, color = '#0F3CC9' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M12 10a2 2 0 0 0-1.433.607L5.333 8.18c.004-.06.004-.12 0-.18.004-.06.004-.12 0-.18l5.254-2.427A2 2 0 1 0 10 4c-.003.06-.003.12 0 .18L4.767 6.607a2 2 0 1 0 0 2.786L10 11.82c-.003.06-.003.12 0 .18a2 2 0 1 0 2-2Z"
    />
  </Svg>
)
export default Share
